import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import MyDialog from '@/components/MyDialog.vue';
let LinkModal = class LinkModal extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
    }
};
__decorate([
    Prop(String)
], LinkModal.prototype, "title", void 0);
__decorate([
    Prop(String)
], LinkModal.prototype, "link", void 0);
LinkModal = __decorate([
    Component({
        components: {
            MyDialog
        }
    })
], LinkModal);
export default LinkModal;
